module.exports = __webpack_public_path__ + "img/2.e8950635.png";